import { ReactHeight } from 'react-height';
import { H as HeaderColorways, u as useBookends, a as useContactLinks, b as useSupplementaryLinks, c as useShortcuts, d as useIsEcommerce, e as useHeaderHeightState } from './index-905103ef.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useRef, useState, createRef, forwardRef, Suspense, lazy } from 'react';
import { Container, Row, Column } from '@uds/grid';
import Colorway from '@uds/colorway';
import './mastheaddesktop.stylesheet_12v6sm.css';
import { u as useWithClickOutside, a as useToggleDropdown, M as MastheadPopoutButton, P as Popout, b as PopoutLink, c as MastheadLink, d as useAccountOptions, U as UserDetails, L as Logo, C as CurrencyPicker, e as LanguagePicker, N as NavLink } from './NavLink-4dd1029a.js';
import { Message, getMessage } from '@uds/message';
import { useIntl } from 'react-intl';
import './mastheaddesktoplinks.stylesheet_13c8ubx.css';
import { Glyph } from '@uds/glyphs';
import { cssTheme, useTheme, gu2px } from '@uds/theme-utils';
import './accountlinks.stylesheet_90taty.css';
import './accountoptionsdesktop.stylesheet_f572fx.css';
import { cx } from 'linaria';
import './accountlinkdesktop_pm7hlg.css';
import './navigationdesktop.stylesheet_jj6u9o.css';
import { classNames as classNames$2, Heading02, BodyCopy, Heading06 } from '@uds/typography';
import './navigationitem.stylesheet_pi9h7n.css';
import { dispatchGAEvent } from '@uds/tagmg';
import './submenu.stylesheet_18dxq3x.css';
import Illustration from '@uds/illustrations';
import './submenulayout.stylesheet_1xvukkn.css';
import './submenulink.stylesheet_ym6l76.css';
import '@ux/accounts-client';
import '@ux/whitelabel';
import '@ux/auth';
import 'react-query';
import '@uds/cookies';
import '@ux/drivers';
import 'jwt-decode';
import '@ux/language';
import '@ux/bus';
import './footer.stylesheet_1cai24r.css';
import './footerlogo.stylesheet_1nwsfvw.css';
import '@uds/link';
import './footerlinks.stylesheet_1tdonhv.css';
import './footerlinkgroup.stylesheet_1k80bmr.css';
import './footerlink.stylesheet_1la25ae.css';
import './footerlegallinks.stylesheet_11hu4qw.css';
import './footersocial.stylesheet_1vs2jgr.css';
import '@uds/padding-box';
import './footercopyright.stylesheet_1vs80r0.css';
import '@artsy/fresnel';
import '@ux/currency';
import '@uds/currency-symbol';
import './currency.stylesheet_1ps9h4b.css';
import '@uds/hooks';
import 'is-uuid';
import '@uds/flag';
import './languagelabel.stylesheet_1bydy.css';
import './picker.stylesheet_1sdqf0u.css';
import './mastheadpopoutbutton.stylesheet_1ta9x9o.css';
import './mastheadlink.stylesheet_1pwh77h.css';
import './popout.stylesheet_yym5ms.css';
import './popoutlink.stylesheet_1a3xsog.css';
import './userdetails.stylesheet_19hsuiq.css';
import '@uds/badge';
import './navlink.stylesheet_dtzwwk.css';

const useMastheadLinks = _ref => {
  let {
    links,
    messageId,
    intl,
    opened,
    onClick,
    refButton,
    refLinks
  } = _ref;
  const ref = useRef(null);
  const [indexDropdown, setIndexDropdown] = useState(-1);
  const [search, setSearch] = useState('');
  useWithClickOutside({
    ref,
    open: opened,
    onClick
  });
  const updateSelected = index => {
    var _refLinks$current$ind, _refLinks$current$ind2;
    setIndexDropdown(index);
    // focus on link selected inside of the dropdown
    (_refLinks$current$ind = refLinks.current[index].current) === null || _refLinks$current$ind === void 0 ? void 0 : (_refLinks$current$ind2 = _refLinks$current$ind.firstElementChild) === null || _refLinks$current$ind2 === void 0 ? void 0 : _refLinks$current$ind2.focus();
  };
  const focusOnSelector = () => {
    var _refButton$current;
    setIndexDropdown(-1);
    onClick();
    // focus on main button of the dropdown
    ((_refButton$current = refButton.current) === null || _refButton$current === void 0 ? void 0 : _refButton$current.firstElementChild).focus();
  };
  const searchOption = keyPressed => {
    const string = `${search}${keyPressed}`;
    setSearch(string);
    const matched = links.findIndex((link, index) => {
      var _link$key, _label$toString;
      const label = intl.formatMessage({
        id: `${messageId}.${(_link$key = link.key) != null ? _link$key : index}.label`
      });
      return new RegExp(`^${string}`, 'ig').test((_label$toString = label === null || label === void 0 ? void 0 : label.toString()) != null ? _label$toString : '');
    });
    if (matched >= 0) {
      updateSelected(matched);
    }
  };
  const onMenuKeyPress = e => {
    if (e.key === 'Enter') {
      onClick();
    } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (opened) {
        updateSelected(0);
      } else {
        onClick();
      }
    } else if (e.key === 'Home') {
      e.preventDefault();
      if (opened) {
        updateSelected(0);
      }
    } else if (e.key === 'End') {
      e.preventDefault();
      if (opened) {
        updateSelected(links.length - 1);
      }
    } else if (e.key !== 'Escape' && e.key !== 'Tab') {
      searchOption(e.key);
    }
  };
  const onItemKeyPress = e => {
    if (e.key !== 'Enter') {
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (opened) {
          if (indexDropdown === 0) {
            focusOnSelector();
          } else if (indexDropdown > 0) {
            updateSelected(indexDropdown - 1);
          } else {
            onClick();
          }
        } else {
          onClick();
        }
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (opened) {
          if (links.length > 0 && indexDropdown < links.length - 1) {
            updateSelected(indexDropdown + 1);
          }
        } else {
          onClick();
        }
      } else if (e.key === 'Tab') {
        if (opened && links.length > 0 && indexDropdown < links.length - 1) {
          e.preventDefault();
          updateSelected(indexDropdown + 1);
        } else {
          onClick();
        }
      } else if (e.key === 'Escape') {
        onClick();
      } else if (e.key === 'Home') {
        e.preventDefault();
        if (opened) {
          updateSelected(0);
        }
      } else if (e.key === 'End') {
        e.preventDefault();
        if (opened) {
          updateSelected(links.length - 1);
        }
      } else {
        searchOption(e.key);
      }
    }
  };
  return {
    ref,
    onMenuKeyPress,
    onItemKeyPress
  };
};

const root$5 = "r11widxo";
const inner = "iv6pv8h";
const logo = "l18ifg91";
const shortcutsContainer = "s1ckhqea";
const shortcuts = "s1mll6yt";
const utils = "u1yq2cmp";
const classNames$1 = {
  root: root$5,
  inner,
  logo,
  shortcutsContainer,
  shortcuts,
  utils
};

const root$4 = "r1yu47e3";
const link$3 = "l10fajna";
const classnames$4 = {
  root: root$4,
  link: link$3
};

const MastheadDesktopLinks = _ref => {
  let {
    links,
    label,
    linkId,
    messageId
  } = _ref;
  const {
    isOpen,
    toggle
  } = useToggleDropdown();
  const refButton = useRef(null);
  const refLinks = useRef(Array.from({
    length: links.length
  }, () => /*#__PURE__*/createRef()));
  const {
    ref,
    onMenuKeyPress,
    onItemKeyPress
  } = useMastheadLinks({
    links,
    messageId,
    intl: useIntl(),
    opened: isOpen != null ? isOpen : false,
    onClick: toggle != null ? toggle : () => {},
    refButton,
    refLinks
  });
  return /*#__PURE__*/jsx(Fragment, {
    children: links.length > 0 && /*#__PURE__*/jsxs("div", {
      ref: ref,
      className: classnames$4.root,
      children: [/*#__PURE__*/jsx(MastheadPopoutButton, {
        ref: refButton,
        popoutOpened: isOpen,
        onClick: toggle,
        onKeyPress: onMenuKeyPress,
        children: /*#__PURE__*/jsx(Message, {
          id: label
        })
      }), isOpen && /*#__PURE__*/jsx(Popout, {
        label: `Popout menu`,
        children: /*#__PURE__*/jsx(Fragment, {
          children: links === null || links === void 0 ? void 0 : links.map((link, index) => {
            var _link$key, _link$key2;
            const {
              tel
            } = link;
            return /*#__PURE__*/jsx(PopoutLink, {
              className: classnames$4.link,
              children: /*#__PURE__*/jsx(MastheadLink, {
                ref: refLinks.current[index],
                id: link.analyticsKey != null ? `${linkId}-${link.analyticsKey}` : undefined,
                href: tel == null ? link.url : `tel:${tel}`,
                label: `${messageId}.${(_link$key2 = link.key) != null ? _link$key2 : index}.label`,
                onKeyPress: onItemKeyPress,
                formatted: 'formatted' in link ? link.formatted : undefined
              })
            }, (_link$key = link.key) != null ? _link$key : index);
          })
        })
      })]
    })
  });
};
MastheadDesktopLinks.displayName = 'MastheadDesktopLinks';
var MastheadDesktopLinks$1 = MastheadDesktopLinks;

const glyph = "g13b1x10";
const getGlyphStyle = function () {
  let colorway = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HeaderColorways.HEADER;
  return {
    classname: glyph,
    color: colorway === HeaderColorways.LIGHT || colorway === HeaderColorways.NEUTRAL ? cssTheme.palette.grey02 : cssTheme.palette.headerForeground,
    height: cssTheme.gu3
  };
};

const root$3 = "r1h9m04t";
const list = "lc3w0y1";
const link$2 = "l1q8tdh";
const classnames$3 = {
  root: root$3,
  list,
  link: link$2
};

const defaultLi = "d1begylo";
const AccountLinkDesktop = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    link,
    classname,
    onKeyPress
  } = _ref;
  return /*#__PURE__*/jsx("li", {
    className: cx(classname, defaultLi),
    children: /*#__PURE__*/jsx(PopoutLink, {
      children: /*#__PURE__*/jsx(MastheadLink, {
        ref: ref,
        ...link,
        id: link.key,
        onKeyPress: onKeyPress
      })
    })
  });
});
AccountLinkDesktop.displayName = 'AccountLinkDesktop';
var AccountLinkDesktop$1 = AccountLinkDesktop;

const AccountOptionsDesktop = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    onKeyPress
  } = _ref;
  const {
    loggedIn,
    hasAccount,
    userDetails,
    links,
    linksLogged,
    linksLogout
  } = useAccountOptions();
  const refLink = ref;
  return /*#__PURE__*/jsxs("div", {
    className: classnames$3.root,
    children: [loggedIn && hasAccount && userDetails && /*#__PURE__*/jsx(UserDetails, {
      ...userDetails
    }), /*#__PURE__*/jsxs("ul", {
      className: classnames$3.list,
      children: [links.map((link, index) => {
        var _link$key;
        return /*#__PURE__*/jsx(AccountLinkDesktop$1, {
          ref: refLink === null || refLink === void 0 ? void 0 : refLink.current[index],
          onKeyPress: onKeyPress,
          link: {
            key: link.analyticsKey != null ? `bks-account-menu-${link.analyticsKey}` : undefined,
            href: link.url,
            label: `bks.account.menu.item.${(_link$key = link.key) != null ? _link$key : index}.label`
          }
        }, link.key);
      }), (loggedIn ? linksLogged : linksLogout).map((link, index) => /*#__PURE__*/jsx(AccountLinkDesktop$1, {
        ref: refLink === null || refLink === void 0 ? void 0 : refLink.current[index + links.length],
        onKeyPress: onKeyPress,
        link: link,
        classname: classnames$3.link
      }, link.key))]
    })]
  });
});
AccountOptionsDesktop.displayName = 'AccountOptionsDesktop';
var AccountOptionsDesktop$1 = AccountOptionsDesktop;

const AccountLinks = () => {
  const intl = useIntl();
  const {
    isOpen,
    toggle
  } = useToggleDropdown();
  const {
    loggedIn,
    links,
    linksLogged,
    linksLogout
  } = useAccountOptions();
  const linksAccount = [...links, ...(loggedIn ? linksLogged : linksLogout)];
  const refButton = useRef(null);
  const refLinks = useRef(Array.from({
    length: linksAccount.length
  }, () => /*#__PURE__*/createRef()));
  const {
    ref,
    onMenuKeyPress,
    onItemKeyPress
  } = useMastheadLinks({
    links: linksAccount,
    messageId: `bks.account.menu.item`,
    intl,
    opened: isOpen != null ? isOpen : false,
    onClick: toggle != null ? toggle : () => {},
    refButton,
    refLinks
  });
  const {
    colorway
  } = useBookends();
  const glyphStyle = getGlyphStyle(colorway);
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: classnames$4.root,
    children: [/*#__PURE__*/jsx(MastheadPopoutButton, {
      ref: refButton,
      popoutOpened: isOpen,
      onClick: toggle,
      onKeyPress: onMenuKeyPress,
      showArrow: false,
      children: /*#__PURE__*/jsx("span", {
        className: glyphStyle.classname,
        children: /*#__PURE__*/jsx(Glyph, {
          size: glyphStyle.height,
          color: glyphStyle.color,
          name: "avatar",
          alt: getMessage({
            id: 'bks.masthead.account'
          }, intl)
        })
      })
    }), isOpen && /*#__PURE__*/jsx(Popout, {
      flush: true,
      label: `Popout account`,
      children: /*#__PURE__*/jsx(AccountOptionsDesktop$1, {
        ref: refLinks,
        onKeyPress: onItemKeyPress
      })
    })]
  });
};
AccountLinks.displayName = 'AccountLinks';
var AccountLinks$1 = AccountLinks;

const Basket = /*#__PURE__*/lazy(() => import('./BasketBanner-33c251bf.js').then(module => ({
  default: module.default
})));
const MastheadDesktop = () => {
  const contactLinks = useContactLinks();
  const supplementaryLinks = useSupplementaryLinks();
  const shortcutNav = useShortcuts();
  const isEcommerce = useIsEcommerce();
  const {
    colorway
  } = useBookends();
  return /*#__PURE__*/jsx(Colorway, {
    colorway: colorway,
    className: classNames$1.root,
    children: /*#__PURE__*/jsx(Container, {
      children: /*#__PURE__*/jsxs("div", {
        className: classNames$1.inner,
        children: [/*#__PURE__*/jsx(Logo, {
          classname: classNames$1.logo
        }), /*#__PURE__*/jsxs("div", {
          className: classNames$1.shortcutsContainer,
          children: [/*#__PURE__*/jsxs("div", {
            className: classNames$1.shortcuts,
            children: [shortcutNav.map(shortcut => {
              var _shortcut$analyticsKe;
              return /*#__PURE__*/jsx(MastheadLink, {
                id: shortcut.analyticsKey != null ? `bks-${shortcut.analyticsKey}` : undefined,
                label: shortcut.label,
                href: shortcut.url,
                glyph: {
                  icon: shortcut.icon
                }
              }, (_shortcut$analyticsKe = shortcut.analyticsKey) != null ? _shortcut$analyticsKe : shortcut.url);
            }), /*#__PURE__*/jsx(MastheadDesktopLinks$1, {
              links: supplementaryLinks,
              label: 'bks.header.supplementary.menu.open',
              linkId: `bks-more-menu`,
              messageId: `bks.header.supplementary.menu.items`
            })]
          }), /*#__PURE__*/jsxs("div", {
            className: classNames$1.utils,
            children: [/*#__PURE__*/jsx(MastheadDesktopLinks$1, {
              links: contactLinks,
              label: 'bks.header.supplementary.contact.open',
              linkId: `bks-contact-menu`,
              messageId: `bks.header.contact.menu.items`
            }), /*#__PURE__*/jsx(CurrencyPicker, {}), /*#__PURE__*/jsx(LanguagePicker, {}), isEcommerce && /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsx(Suspense, {
                fallback: "",
                children: /*#__PURE__*/jsx(Basket, {
                  isEcommerce: isEcommerce,
                  label: 'bks.header.basketCount.desktop'
                })
              }), /*#__PURE__*/jsx(AccountLinks$1, {})]
            })]
          })]
        })]
      })
    })
  });
};
MastheadDesktop.displayName = 'MastheadDesktop';
var MastheadDesktop$1 = MastheadDesktop;

const root$2 = "r1evr38s";
const topmenu = "t3zyvea";
const nav = "ny9chpz";
const classnames$2 = {
  root: root$2,
  topmenu,
  nav
};

const divider = "dsuh11b";
const link$1 = "l14jqapo";
const classNames = {
  divider,
  link: cx(classNames$2.headingXs, link$1)
};

const submenu = "s1kp0rv3";
const classnames$1 = {
  submenu
};

const submenuBase = {
  default: "d8k44n",
  opened: "obvsx9k"
};
const root$1 = "r13b2dm1";
const title$1 = "txrw4gm";
const getClassNames = _ref => {
  let {
    opened
  } = _ref;
  return {
    submenuBase: cx(submenuBase.default, opened && submenuBase.opened),
    root: cx(classNames$2.headingXxs, root$1),
    title: title$1
  };
};

const SubmenuLayout = _ref => {
  let {
    children,
    submenu,
    opened
  } = _ref;
  const {
    theme
  } = useTheme();
  const classnames = getClassNames({
    opened
  });
  const {
    colorwaySecondary
  } = useBookends();
  return /*#__PURE__*/jsx(Colorway, {
    colorway: colorwaySecondary,
    className: classnames.submenuBase,
    children: /*#__PURE__*/jsx(Container, {
      children: submenu.illustrationKey != null ? /*#__PURE__*/jsxs(Row, {
        children: [/*#__PURE__*/jsx(Column, {
          xs: 4,
          children: /*#__PURE__*/jsxs("div", {
            className: classnames.root,
            children: [/*#__PURE__*/jsx(Illustration, {
              size: gu2px(16, theme.spacing),
              icon: submenu.illustrationKey
            }), submenu.title != null && /*#__PURE__*/jsx(Heading02, {
              className: classnames.title,
              children: /*#__PURE__*/jsx(Message, {
                id: submenu.title
              })
            }), submenu.body != null && /*#__PURE__*/jsx(BodyCopy, {
              children: /*#__PURE__*/jsx(Message, {
                id: submenu.body
              })
            })]
          })
        }), /*#__PURE__*/jsx(Column, {
          xs: 8,
          children: children
        })]
      }) : children
    })
  });
};
SubmenuLayout.displayName = 'SubmenuLayout';
var SubmenuLayout$1 = SubmenuLayout;

const iconStyle = {
  height: cssTheme.gu3,
  color: 'primary'
};
const title = "t6iqxai";
const icon = "i6varty";
const link = "ltkif27";
const body = "bz4g527";
const root = "rxcklhl";
const classnames = {
  root: cx(classNames$2.headingXxs, root),
  link,
  title,
  icon,
  body: cx(link, body)
};

const SubmenuLink = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    title,
    body,
    href,
    analyticsKey,
    promo,
    promoLabel
  } = _ref;
  const {
    LinkComponent
  } = useBookends();
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: classnames.root,
    children: [/*#__PURE__*/jsxs(LinkComponent, {
      id: analyticsKey != null ? `bks-submenu-${analyticsKey}` : undefined,
      href: href,
      className: classnames.link,
      children: [/*#__PURE__*/jsx(Heading06, {
        component: "div",
        className: classnames.title,
        children: /*#__PURE__*/jsx(NavLink, {
          label: title,
          promo: promo,
          promoLabel: promoLabel
        })
      }), /*#__PURE__*/jsx("span", {
        className: classnames.icon,
        children: /*#__PURE__*/jsx(Glyph, {
          name: "arrowRight",
          size: iconStyle.height,
          color: iconStyle.color
        })
      })]
    }), body != null && /*#__PURE__*/jsx(LinkComponent, {
      href: href,
      className: classnames.body,
      tabIndex: -1,
      children: /*#__PURE__*/jsx(BodyCopy, {
        children: /*#__PURE__*/jsx(Message, {
          id: body
        })
      })
    })]
  });
});
SubmenuLink.displayName = 'SubmenuLink';
var SubmenuLink$1 = SubmenuLink;

const Submenu = _ref => {
  let {
    submenu,
    opened
  } = _ref;
  return /*#__PURE__*/jsx(SubmenuLayout$1, {
    submenu: submenu,
    opened: opened,
    children: /*#__PURE__*/jsx(Row, {
      className: classnames$1.submenu,
      children: submenu.items.map(link => /*#__PURE__*/jsx(Column, {
        xs: submenu.illustrationKey == null ? 4 : 6,
        children: /*#__PURE__*/jsx(SubmenuLink$1, {
          title: link.title,
          body: link.body,
          href: link.url,
          analyticsKey: link.analyticsKey,
          promo: link.promo,
          promoLabel: link.promoLabel
        })
      }, link.key))
    })
  });
};
Submenu.displayName = 'Submenu';
var Submenu$1 = Submenu;

function SubmenuContainer(_ref) {
  let {
    closeSubmenu,
    isOpen,
    submenu,
    id
  } = _ref;
  const trackDropdownHover = () => {
    dispatchGAEvent({
      hitType: 'event',
      eventCategory: 'Custom',
      eventAction: 'hover',
      eventLabel: 'bks-navlink-dropdown-hover'
    });
  };
  return /*#__PURE__*/jsx("div", {
    id: `bks-subnav-${id}`,
    onMouseEnter: () => trackDropdownHover(),
    onClick: () => closeSubmenu(),
    onKeyDown: ev => ev.key === 'Enter' || ev.key === 'Escape' && closeSubmenu(),
    role: "presentation",
    children: /*#__PURE__*/jsx(Submenu$1, {
      submenu: submenu,
      opened: isOpen
    })
  });
}

function NavigationItem(_ref) {
  var _link$submenu;
  let {
    id,
    isCurrent,
    isExpanded,
    handleMouseOver,
    handleFocus,
    link,
    ...rest
  } = _ref;
  const {
    LinkComponent
  } = useBookends();
  return /*#__PURE__*/jsxs("span", {
    className: classNames.divider,
    onMouseOver: handleMouseOver,
    onFocus: handleFocus,
    role: "menuitem",
    children: [/*#__PURE__*/jsx(LinkComponent, {
      id: `bks-navlink-${id}`,
      href: link.url,
      isNavLink: true,
      isNavLinkExact: link.exact,
      className: classNames.link,
      "aria-current": isCurrent ? 'page' : undefined,
      "aria-expanded": isExpanded,
      tabIndex: 0,
      children: /*#__PURE__*/jsx(NavLink, {
        label: link.label,
        promo: link.promo,
        promoLabel: link.promoLabel
      })
    }), (link === null || link === void 0 ? void 0 : link.submenu) != null && (link === null || link === void 0 ? void 0 : (_link$submenu = link.submenu) === null || _link$submenu === void 0 ? void 0 : _link$submenu.items.length) > 0 && /*#__PURE__*/jsx(SubmenuContainer, {
      id: id,
      submenu: link.submenu,
      ...rest
    })]
  }, `bks-nav-${id}`);
}

const NavigationDesktop = _ref => {
  let {
    links,
    menuItemActiveIndex
  } = _ref;
  const {
    colorwaySecondary
  } = useBookends();
  const [activeIndex, setActiveIndex] = useState(-1);
  const closeSubmenu = () => setActiveIndex(-1);
  return /*#__PURE__*/jsx(Colorway, {
    colorway: colorwaySecondary,
    className: classnames$2.root,
    children: /*#__PURE__*/jsx("nav", {
      role: "menubar",
      className: classnames$2.topmenu,
      children: /*#__PURE__*/jsx("div", {
        className: classnames$2.nav,
        onMouseLeave: closeSubmenu,
        children: links.map((link, indexLink) => {
          var _ref2, _link$analyticsKey;
          const key = (_ref2 = (_link$analyticsKey = link.analyticsKey) != null ? _link$analyticsKey : link.key) != null ? _ref2 : indexLink;
          return /*#__PURE__*/jsx(NavigationItem, {
            id: key,
            isCurrent: menuItemActiveIndex === indexLink,
            isExpanded: activeIndex === indexLink,
            closeSubmenu: closeSubmenu,
            handleFocus: () => setActiveIndex(indexLink),
            handleMouseOver: () => setActiveIndex(indexLink),
            link: link,
            isOpen: activeIndex === indexLink
          }, key);
        })
      })
    })
  });
};
NavigationDesktop.displayName = 'NavigationDesktop';
var NavigationDesktop$1 = NavigationDesktop;

const HeaderDesktop = props => {
  const [, setHeight] = useHeaderHeightState();
  return /*#__PURE__*/jsx(ReactHeight, {
    onHeightReady: setHeight,
    children: /*#__PURE__*/jsxs("header", {
      children: [/*#__PURE__*/jsx(MastheadDesktop$1, {}), /*#__PURE__*/jsx(NavigationDesktop$1, {
        ...props
      })]
    })
  });
};
HeaderDesktop.displayName = 'HeaderDesktop';

export { HeaderDesktop as default };
